import React, { useEffect, useState } from "react";
import InputField from "./InputField";
import { Back } from "../../../ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { newPasswordUser } from "../../../store/authSlice";
import { useTranslation } from 'react-i18next';

const AccountSecurity = ({ setActiveTab, activeTab, isMobile }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        email: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [state, setState] = useState();
    const dispatch = useDispatch();
    const { user, errorNewPassword } = useSelector((store) => store.auth);

    useEffect(() => {
        setFormData({...formData, email: user?.email});
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.newPassword !== formData.confirmPassword) {
            setState(t('account_security.errors.password_mismatch'));
            return;
        }

        const commonPasswords = ["password", "12345678", "qwerty", "letmein", "123456789", "football"];
        if (commonPasswords.includes(formData.newPassword.toLowerCase())) {
            setState(t('account_security.errors.common_password'));
            return;
        }

        if (formData.newPassword.length < 8) {
            setState(t('account_security.errors.short_password'));
            return;
        }

        if (/^\d+$/.test(formData.newPassword)) {
            setState(t('account_security.errors.numeric_password'));
            return;
        }

        dispatch(newPasswordUser({email: formData.email, new_password: formData.newPassword}));
        setState(t('account_security.success.password_changed'));
    };

    return (
        <>
            <div className="flex items-center gap-5 pb-2 pt-2 pl-5 shadow-md sm:shadow-none">
                {activeTab && isMobile && (
                    <button
                        className="cursor-pointer"
                        onClick={() => setActiveTab(null)}
                    >
                        <Back />
                    </button>
                )}
                <p className='font-normal text-lg'>{t('account_security.title')}</p>
            </div>
            <form className="px-6" onSubmit={handleSubmit}>
                <p className="pb-5 pt-5">{t('account_security.description')}</p>

                <InputField
                    label={t('account_security.email_label')}
                    type='email'
                    placeholder={t('account_security.email_placeholder')}
                    width="100%"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                />

                <h2 className="pt-5 pb-2 font-semibold text-lg">{t('account_security.change_password')}</h2>
                <div className='flex flex-col gap-4'>
                    <InputField
                        label={t('account_security.new_password_label')}
                        type='password'
                        placeholder={t('account_security.password_placeholder')}
                        width="100%"
                        name="newPassword"
                        value={formData?.newPassword}
                        onChange={handleChange}
                    />
                    <InputField
                        label={t('account_security.confirm_password_label')}
                        type='password'
                        placeholder={t('account_security.password_placeholder')}
                        width="100%"
                        name="confirmPassword"
                        value={formData?.confirmPassword}
                        onChange={handleChange}
                    />
                    <button 
                        type="submit" 
                        className='text-[#FFF] mt-4 py-2 bg-[#8C1C1C] rounded-2xl font-semibold w-[70%] sm:w-[30%]'
                    >
                        {t('account_security.update_button')}
                    </button>
                    {state && (
                        <p style={{ color: state === t('account_security.success.password_changed') ? "green" : "red" }}>
                            {state}
                        </p>
                    )}
                </div>
            </form>
            <button
                className='py-2 block sm:hidden rounded-xl sm:rounded-2xl font-semibold text-base w-[90%] sm:w-[30%] bg-[#402D1D] text-[#FFF]'
                style={{ position: 'absolute', bottom: '30px', left: "50%", transform: "translateX(-50%)" }}
            >
                {t('account_security.save_button')}
            </button>
        </>
    );
};

export default AccountSecurity;